"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SerializationError = exports.createSerializationErrorAndLog = void 0;
const errors_1 = require("../errors");
/**
 * Logs error and creates an DynamoDBError object
 * @param reason reason to log
 * @param de serialized data element
 * @param innerError error object to add to the reason
 * @param logger logger (optional)
 * @returns SerializationError object
 */
function createSerializationErrorAndLog(reason, de, innerError, logger) {
    const errMessage = `Failed to deserialize data element: ${reason} ${innerError ? JSON.stringify(innerError) : ""}. Object is ${JSON.stringify(de)}`;
    if (logger) {
        logger.error(errMessage);
    }
    return new SerializationError(errMessage, innerError);
}
exports.createSerializationErrorAndLog = createSerializationErrorAndLog;
class SerializationError extends errors_1.BaseError {
    constructor(message, obj, innerError) {
        super(message, innerError);
    }
}
exports.SerializationError = SerializationError;
//# sourceMappingURL=serialization.js.map